import { render, staticRenderFns } from "./WikiLink.vue?vue&type=template&id=3b57d6fe&scoped=true&"
import script from "./WikiLink.vue?vue&type=script&lang=js&"
export * from "./WikiLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57d6fe",
  null
  
)

export default component.exports